import PressBanner from './PressBanner';

export default PressBanner;
